import { render, staticRenderFns } from "./UpperNavbar.vue?vue&type=template&id=3391b163&"
import script from "./UpperNavbar.vue?vue&type=script&lang=js&"
export * from "./UpperNavbar.vue?vue&type=script&lang=js&"
import style0 from "./UpperNavbar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports